import React from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import BranchesAction from "store/branch-resource/actions"
import { useHistory } from "react-router-dom"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import SButton from "components/Common/Button"
import { MetaTags } from "react-meta-tags"
import Skeleton from "react-loading-skeleton"
import TableContainer from "components/newTables/TableContainer"

export default function EnterpriseCustomerManagement() {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(state => state.branches)
  const [params, setParams] = React.useState({
    page: 0,
    size: 10,
  })
  const [pagination, setPagination] = React.useState({
    page: 0,
    size: 10,
  })
  const [filter, setFilter] = React.useState({
    companyName: "",
    branchName: "",
  })

  React.useEffect(() => {
    dispatch(BranchesAction.getListPage({ ...params, ...pagination }))
  }, [params, pagination])

  const columns = React.useMemo(
    () => [
      {
        Header: "企業名",
        accessor: "companyName",
        disableSortBy: true,
      },
      {
        Header: "店舗名",
        accessor: "branchName",
        disableSortBy: true,
      },

      {
        Header: "都道府県",
        accessor: "prefectures",
        defaultCanSort: true,
        disableSortBy: true,
      },
      {
        Header: "住所",
        accessor: "address",
        defaultCanSort: true,
        disableSortBy: true,

        Cell: props => {
          return (
            <span>
              {props.cell.row.original?.postalCode}{" "}
              {props.cell.row.original?.address}
            </span>
          )
        },
      },
      {
        Header: "",
        accessor: "action",
        disableSortBy: true,
        Cell: cell => {
          return (
            <SButton
              className="button"
              onClick={() =>
                history.push(
                  `/enterprise-customer-management/brand/${cell.row.original.id}`
                )
              }
            >
              詳細
            </SButton>
          )
        },
      },
    ],
    []
  )

  const onChangeFilter = e => {
    const { name, value } = e.target
    setFilter({
      ...filter,
      [name]: value,
    })
  }

  const onSearch = () => {
    setPagination({ page: 0, size: 10 })
    setParams({
      ...filter,
      page: 0,
      size: 10,
    })
  }

  return (
    <>
      <MetaTags>
        <title>企業顧客管理 | Igarashi Trousers</title>
      </MetaTags>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"企業顧客管理"} breadcrumbList={[]} />

          <Card>
            <CardBody>
              <Row>
                <Col lg={2}>
                  <TextInputWithLabel
                    label={"会社名"}
                    placeholder={""}
                    type="text"
                    name="companyName"
                    onChange={onChangeFilter}
                    value={filter.companyName}
                  />
                </Col>
                <Col lg={2}>
                  <TextInputWithLabel
                    label={"店舗名"}
                    placeholder={""}
                    type="text"
                    name="branchName"
                    onChange={onChangeFilter}
                    value={filter.branchName}
                  />
                </Col>
                <Col lg={2} className="align-self-end">
                  <SButton onClick={() => onSearch()} className="button">
                    検索
                  </SButton>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <Row className="mb-3">
                <Col sm="6" />
                <Col sm="6" className="gap-3 justify-content-end d-flex">
                  <Button
                    className="button"
                    onClick={() =>
                      history.push("/enterprise-customer-management/company")
                    }
                  >
                    新規企業追加
                  </Button>
                  <Button
                    className="button"
                    onClick={() =>
                      history.push("/enterprise-customer-management/brand/add")
                    }
                  >
                    新規店舗追加
                  </Button>
                </Col>
              </Row>
              <Row className="mb-2">
                {store.branchesPage.loading ? (
                  <Skeleton count={5} />
                ) : store.branchesPage.data?.content?.length === 0 ? (
                  <h3 className="text-center">No Data to Display</h3>
                ) : (
                  <TableContainer
                    data={store.branchesPage.data?.content || []}
                    columns={columns}
                    pagination
                    page={pagination.page}
                    size={pagination.size}
                    count={store.branchesPage.data?.totalPages || 1}
                    setParams={setPagination}
                    params={pagination}
                  />
                )}
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}
